import React, { type AnchorHTMLAttributes, useMemo } from 'react';

import { type BaseDepButtonProps } from './DepButton';
import './DepButton.scss';

export type DepExternalLinkButtonProps = BaseDepButtonProps & AnchorHTMLAttributes<HTMLAnchorElement>;

export function DepExternalLinkButton({
    children,
    variant,
    size,
    disabled,
    glow,
    classes,
    display,
    ...props
}: DepExternalLinkButtonProps) {
    const classNames = useMemo(() => {
        let classNames = 'yat-button';
        if (variant) classNames += ` yat-button--${variant}`;
        if (size) classNames += ` yat-button--${size}`;
        if (disabled) classNames += ` yat-button--disabled`;
        if (glow) classNames += ` yat-button--glow`;
        if (display) classNames += ` yat-button--${display}`;
        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [variant, size, disabled, glow, display, classes]);

    return (
        <a className={classNames} {...props}>
            <span className="yat-button__content">{children}</span>
        </a>
    );
}
